// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"downloadData_wrapper__Tkw_V"};